import type { IFieldMeta } from '@lark-base-open/js-sdk';

export type SortDirection = 'asc' | 'desc';
export type RecordRange = 'visible' | 'selected' | 'all';

export type FieldMeta = IFieldMeta;

export interface FieldOption {
  id: string;
  name: string;
  type: number;
  checked: boolean;
  order: number;
}

export interface PrintSettings {
  paperSize: 'A4' | 'A5' | 'A3' | 'Letter';
  orientation: 'portrait' | 'landscape';
  marginMm: number;
  fontSizePx: number;
  showIndex: boolean;
  title: string;
}

export interface Template {
  id: string;
  tableId: string;
  name: string;
  fieldIds: string[];
  settings: PrintSettings;
  createdAt: number;
  updatedAt: number;
}

export interface UserPreferences {
  lastTemplateIdByTable: Record<string, string>;
  /** 记录模板（合同模式）当前选中的模板，按表记。不持久化的话，每次进出
   *  页面都会跳回「最近编辑过的那个」，客户容易照着错的模板打印。 */
  lastContractTemplateIdByTable?: Record<string, string>;
}

export interface TableContext {
  tableId: string;
  viewId: string;
}

export class BitableApiError extends Error {
  readonly code: string;
  override cause?: unknown;
  constructor(code: string, message: string, cause?: unknown) {
    super(message);
    this.name = 'BitableApiError';
    this.code = code;
    this.cause = cause;
  }
}
